import invariant from 'invariant';

/* eslint consistent-return: 0 */
interface Window {
  TMS?: any;
  isUtagEnabled?: boolean;
}

/**
 * getTMS
 * Get global Telium library
 * @param {string} type
 */

export function getTMS(
  type: string,
): (name: string | object, data?: object) => void {
  const globalWindow: Window = window as {};

  invariant(
    globalWindow.TMS !== undefined,
    'Sorry, your TMS library is not imported!',
  );

  return globalWindow.TMS[`track${type}`];
}

/**
 * deriveFunnelName
 * @param {object} { name, step, stepName }
 */
export function deriveFunnelName({
  name,
  step,
  stepName,
}: {
  name?: string;
  step?: string;
  stepName?: string;
}): string {
  return stepName || `${name} ${step}`;
}
